/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgUser = {
  header: 'Todos los usuarios ({{count}})',
  disabled: '(deshabilitado)',
  uid: 'Correo electrónico',
  active: 'Estado',
  name: 'Nombre',
  firstName: 'Nombre',
  lastName: 'Apellido',
  email: 'Correo electrónico',
  orgUnit: 'Unidad',
  unit: 'Unidad',
  roles: 'Papeles',
  rights: 'Derechos',
  title: 'Título',
  hint: 'Los usuarios son los compradores, aprobadores, gerentes y administradores de la organización. A cada usuario se le asigna un rol para realizar o aprobar compras. Cada usuario pertenece a una unidad y tiene acceso a todas las unidades secundarias de su unidad principal.',

  unitApprover: `Unidad aprobadora`,
  assignApprover: 'Agregar el usuario a los aprobadores de la unidad',

  actions: '',

  sortBy: 'Ordenar por',
  sort: {
    byName: 'Nombre',
    byUnit: 'Unidad',
  },

  details: {
    title: 'Detalles del usuario',
    subtitle: 'Usuario: {{ item.name }}',
  },
  edit: {
    title: 'Editar usuario',
    subtitle: 'Usuario: {{ item.name }}',
  },
  create: {
    title: 'Crear usuario',
    subtitle: '',
  },

  links: {
    password: 'Cambiar contraseña',
    approvers: 'Aprobadores',
    userGroup: 'Grupos de usuarios',
    permission: 'Límites de compra',
    rolesAndRights: 'Papeles y Derechos',
  },

  messages: {
    deactivateTitle: 'Disable this user?',
    deactivate:
      'Los usuarios discapacitados no pueden iniciar sesión en la tienda y realizar pedidos.',
    confirmEnabled:
      'Usuario {{item.firstName}} {{item.lastName}} habilitado correctamente',
    confirmDisabled:
      'Usuario {{item.firstName}} {{item.lastName}} deshabilitado correctamente',
    update: 'Usuario {{item.firstName}} {{item.lastName}} actualizado con éxito',
    create: 'Usuario {{item.firstName}} {{item.lastName}} creado con éxito',
    updatePassword:
      'Contraseña de usuario {{item.firstName}} {{item.lastName}} actualizada correctamente',
  },
  info: {
    disabledEdit: 'Habilite al usuario para permitir la edición.',
    disabledEnable: 'Unidad debe estar habilitado antes de que se pueda habilitar este usuario.',
  },

  approver: {
    link: 'Aprobadores',
    header: 'Aprobadores in {{code}}',
    assign: 'Asignación',
    assignHeader: 'Asignación in {{code}}',
    back: 'Atrás',
    new: 'Nuevo aprobador',
    instructions: {
      check: "Para asignar un aprobador a este usuario, active la casilla de verificación del usuario.",
      uncheck: "Para quitar un aprobador, desactive la casilla de verificación del usuario.",
      changes: 'Los cambios se guardan automáticamente.',
    },
  },

  userGroup: {
    link: 'Grupos de usuarios',
    header: 'Grupos de usuarios in {{code}}',
    assign: 'Asignar grupos de usuarios',
    assignHeader: 'Asignar grupos de usuarios in {{code}}',
    back: 'Atrás',
    instructions: {
      check:
        "Para asignar un grupo de usuarios a este usuario, active la casilla de verificación del usuario.",
      uncheck: "Para eliminar un grupo de usuarios, desactive la casilla de verificación del usuario.",
      changes: 'Los cambios se guardan automáticamente.',
    },
  },

  permission: {
    link: 'Límites de compra',
    header: 'Límites de compra in {{code}}',
    assign: 'Asignar límites de compra',
    assignHeader: 'Asignar límites de compra in {{code}}',
    back: 'Atrás',
    instructions: {
      check: 'Para asignar un límite de compra a este usuario, seleccione su casilla de verificación.',
      uncheck: 'Para anular la asignación de un límite de compra, desactive su casilla de verificación.',
      changes: 'Los cambios se guardan automáticamente.',
    },
    per: {
      undefined: '',
      MONTH: 'por Mes',
      YEAR: 'por año',
      WEEK: 'por semana',
      QUARTER: 'por Trimestre',
    },
  },

  password: {
    title: 'Cambiar contraseña',
    subtitle: 'Usuario: {{ item.email }}',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Volver a escribir la nueva contraseña',
  },

  breadcrumbs: {
    list: 'Todos los usuarios',
    details: '{{name}}',
    userGroups: 'Grupos de usuarios',
    approvers: 'Aprobadores',
    permissions: 'Límites de compra',
  },
};

export const orgUserAssignedApprovers = {
  title: 'Aprobadores asignados',
  subtitle: 'Usuario: {{ item.name }}',
  assigned: 'Aprobador {{ item.name }} asignado correctamente',
  unassigned: 'Aprobador {{ item.name }} sin asignar correctamente',
};
export const orgUserApprovers = {
  title: 'Administración de aprobadores',
  subtitle: 'Usuario: {{ item.name }}',
  assigned: 'Aprobador {{ item.name }} asignado correctamente',
  unassigned: 'Aprobador {{ item.name }} sin asignar correctamente',
};

export const orgUserAssignedPermissions = {
  title: 'Límites de compra asignados',
  subtitle: 'Usuario: {{ item.name }}',
  assigned: 'Límite de compra {{ item.code }} asignado con éxito',
  unassigned: 'Límite de compra {{ item.code }} desasignado correctamente',
};

export const orgUserPermissions = {
  title: 'Gestionar los límites de compra',
  subtitle: 'Usuario: {{ item.name }}',
  assigned: 'Límite de compra {{ item.code }} asignado con éxito',
  unassigned: 'Límite de compra {{ item.code }} desasignado correctamente',
};

export const orgUserAssignedUserGroups = {
  title: 'Grupos de usuarios asignados',
  subtitle: 'Usuario: {{ item.name }}',
  assigned: 'Grupo de usuarios {{item.name}} asignado correctamente',
  unassigned: 'Grupo de usuarios {{item.name}} desasignado correctamente',
};

export const orgUserUserGroups = {
  title: 'Administrar grupos de usuarios',
  subtitle: 'Usuario: {{ item.name }}',
  assigned: 'Grupo de usuarios {{item.name}} asignado correctamente',
  unassigned: 'Grupo de usuarios {{item.name}} desasignado correctamente',
};
